import axios from '../utils/axios';

export const loginByLocal = async (username, password) => {
  var bodyFormData = {
    username: username,
    password: password,
  }
  let response = await axios({
    method: 'post',
    url: '/api/login',
    data: bodyFormData,
    headers: {'Content-Type': 'application/json' ,
              'Authorization': `Basic ${localStorage.getItem('token')}`
    },
  })
  //handle success
  if( response.data != "" ){
    if( response.data.err == "" ){
      return response.data.token;    
    } else {
      throw new Error(response.data.err);   
    }
  }
  throw new Error("Request Server Error");
};
